export class Search{
    englishName: string = ""
    dd: string = "00"
    mm: string = "00"
    yyyy: string = "0000"
    gender: string = "NO"
    isQuick: boolean = true
}